import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import { SimpleDropdown } from '../../../../simple-dropdown';
import { useAvailableInsuranceOptions } from '../../../../../services/insurance-service';

const messages = defineMessages({
  defaultLabel: {
    description: 'insuranceDropdown.defaultLabel',
    defaultMessage: 'Insurance',
    id: 'zAEEDK',
  },
  defaultTitle: {
    description: 'insuranceDropdown.defaultTitle',
    defaultMessage: 'Please Select',
    id: 'iNCK20',
  },
});

const InsuranceProviderDropdown = ({
  dropdownMenuShouldHaveWidthOfButton = false,
  onInsuranceProviderSelected = noop,
  required = false,
  selectedInsuranceProvider = '',
  hasError = false,
}) => {
  const label = <FormattedMessage {...messages.defaultLabel} />;
  const defaultTitle = <FormattedMessage {...messages.defaultTitle} />;

  const insuranceOptions = useAvailableInsuranceOptions();
  const filteredInsuranceOptions = useMemo(
    () =>
      insuranceOptions.map((i) => ({
        key: i.insuranceOptionId,
        name: <FormattedMessage {...i.messageDescriptor} />,
      })),
    [insuranceOptions],
  );

  return (
    <SimpleDropdown
      defaultTitle={defaultTitle}
      dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
      hasError={hasError}
      items={filteredInsuranceOptions}
      label={label}
      onItemSelected={onInsuranceProviderSelected}
      required={required}
      selectedItemKey={selectedInsuranceProvider}
    />
  );
};

InsuranceProviderDropdown.propTypes = {
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  onInsuranceProviderSelected: PropTypes.func,
  required: PropTypes.bool,
  selectedInsuranceProvider: PropTypes.string,
  hasError: PropTypes.bool,
};

export default InsuranceProviderDropdown;
